/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.trades.details', [])
    .controller('UserTradesDetailsAdminCtrl', UserTradesDetailsAdminCtrl);

  /** @ngInject */
  function UserTradesDetailsAdminCtrl($scope, $state, $stateParams) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    if ($stateParams.details === null) {
      $state.go('admin.users.details.trades',{parentId: vm.userId})
    }

    var items = $stateParams.details;
    var obj = {};
    obj.id = items.id;
    obj.ua = items.ua.username;

    obj.itemsa = "";
    if (items['p-ua'] !== undefined) {
      for (var j = 0; j < items['p-ua'].length; j++) {
        if (j === (items['p-ua'].length - 1)) {
          obj.itemsa += items['p-ua'][j].q.t;
        } else {
          obj.itemsa += items['p-ua'][j].q.t + ', ';
        }
      }
    }

    obj.ub = items.ub.username;

    obj.itemsb = ""
    if (items['p-ub'] !== undefined) {
      for (var j = 0; j < items['p-ub'].length; j++) {
        if (j === (items['p-ub'].length -1)) {
          obj.itemsb += items['p-ub'][j].q.t;
        } else {
          obj.itemsb += items['p-ub'][j].q.t + ', ';
        }
      }
    }

    vm.items = [obj];
  }

})();
